// /**
//  * Static site content sourced from CET-Website-Copy.md + client updates.
//  * Program is 100% online; interviews are virtual.
//  */

// export const LEGAL = {
//   brandName: "CET",
//   brandFull: "Corporate Entrance Test",
//   initiativeBy: "Startup Times",
//   legalEntity: "Devobyte OPC Private Limited",
//   email: "help@corporateentrancetest.com",
//   addressLine: "Corporate Address : A-522, Tower T3, NX One, Tech Zone 4, Noida Extension, Uttar Pradesh 201306",
//   startupTimes: {
//     website: "https://startuptimes.net/",
//     instagram: "https://www.instagram.com/startuptimesofficial/",
//     linkedin: "https://www.linkedin.com/company/startup-times",
//   },
// };

// export const ASSETS = {
//   startupTimesLogo:
//     "https://customer-assets-0z36b82j.emergentagent.net/job_cet-portal-1/artifacts/ezcwih7h_ST%20Logo.png",
//   founderPhoto:
//     "https://customer-assets-0z36b82j.emergentagent.net/job_cet-portal-1/artifacts/1genlp59_sarfrazkhan.png",
//   heroSkyline:
//     "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
// };

// export const IMAGES = {
//   graduatesRed: "https://static.prod-images.emergentagent.com/jobs/465b9496-4539-488c-85f4-478366c7c0e4/images/d50d2c52b5bad49fcc4af9b8361cc1175898e9b381a8533db06090cb108f1f9c.jpeg",
//   capToss: "https://static.prod-images.emergentagent.com/jobs/465b9496-4539-488c-85f4-478366c7c0e4/images/514045a065e9cc7330166ed032e059f0da22487d593f9a1fdee9b9a4983e56f0.jpeg",
//   capToss2: "https://static.prod-images.emergentagent.com/jobs/465b9496-4539-488c-85f4-478366c7c0e4/images/d50d2c52b5bad49fcc4af9b8361cc1175898e9b381a8533db06090cb108f1f9c.jpeg",
//   onlineLearning: "https://static.prod-images.emergentagent.com/jobs/465b9496-4539-488c-85f4-478366c7c0e4/images/fb666feedcb23a09df5d5e82001223b0e53bfc9209e7722f5139b67274d2d755.jpeg",
//   laptopStudy: "https://static.prod-images.emergentagent.com/jobs/465b9496-4539-488c-85f4-478366c7c0e4/images/8d353cb795a72ec7ceb2a32975a3ec8ca64ea721d789bcbbfe48c6508a861c87.jpeg",
//   study2: "https://static.prod-images.emergentagent.com/jobs/465b9496-4539-488c-85f4-478366c7c0e4/images/f28bbbec7e15d19775b446c55f294ecf6a1aec8d4fc2e92fecab05f62fabca28.jpeg",
//   networking: "https://static.prod-images.emergentagent.com/jobs/465b9496-4539-488c-85f4-478366c7c0e4/images/8d353cb795a72ec7ceb2a32975a3ec8ca64ea721d789bcbbfe48c6508a861c87.jpeg",
// };

// export const SITE = {
//   applicationCloseDate: "2026-12-31T23:59:59+05:30",
// };

// export const NAV_LINKS = [
//   { label: "Home", to: "/" },
//   { label: "About", to: "/about" },
//   { label: "Exam Pattern & Syllabus", to: "/exam-pattern-and-syllabus" },
//   { label: "Program", to: "/program" },
//   { label: "Dubai Experience", to: "/dubai-experience" },
//   { label: "FAQs", to: "/faqs" },
//   { label: "Blog", to: "/blog" },
// ];

// export const HERO = {
//   eyebrow: "A NATIONAL PLATFORM CONNECTING STUDENTS WITH CORPORATE OPPORTUNITIES",
//   headlineTop: "Your Degree Gets You Started.",
//   headlineAccent: "CET Gets You in Front of Employers.",
//   subhead:
//     "Take India's Corporate Entrance Test. Earn your National Rank, enter the Corporate Launch Program, gain practical corporate exposure, and get evaluated by a network of 350+ employers for potential career opportunities",
//   tagline: "From Indian Campuses to Global Opportunities",
//   sideIcons: ["Global Exposure", "Employer Connections", "Career Acceleration", "A Bigger You"],
//   microcopy:
//     "For final year students & recent graduates · Applications open October 1, 2026. One national testing window per cycle",
// };

// export const STATS = [
//   { value: "1,000", label: "Enter the Corporate Launch Program" },
//   { value: "20", label: "Will Go to Dubai" },
//   { value: "350+", label: "Participating Employers" },
//   { value: "3 Months", label: "Fully-Sponsored Corporate Training" }
// ];

// export const EMPLOYER_SECTION = {
//   heading: "Backed By a Network of 350+ Employers",
//   subheading: "Across the industries that hire the most corporate-ready talent in India.",
//   industries: [
//     { name: "IT & Consulting", icon: "Code2" },
//     { name: "BFSI", icon: "Landmark" },
//     { name: "Manufacturing & Core", icon: "Factory" },
//     { name: "Marketing & Media", icon: "Megaphone" },
//     { name: "Operations & Supply Chain", icon: "Truck" },
//     { name: "High-Growth Startups", icon: "Rocket" },
//   ],
// };

// export const JOURNEY_STEPS = [
//   { n: "01", title: "Apply for CET", body: "Submit your application between October 1 and December 31, 2026." },
//   { n: "02", title: "Take the Test", body: "Appear for the national online examination on January 31, 2027 — 80 questions across reasoning, aptitude, communication and workplace judgment." },
//   { n: "03", title: "Get Your Rank", body: "Receive your National Rank, percentile, and a personalized Corporate Readiness Report." },
//   { n: "04", title: "Interviews", body: "Shortlisted candidates are interviewed virtually between March 1 and March 31, 2027." },
//   { n: "05", title: "Final Shortlist", body: "The final list of 1,000 selected candidates is declared on April 15, 2027." },
//   { n: "06", title: "Corporate Launch Program", body: "The 3-month online program begins June 1, 2027, followed by employer evaluations and selection of the Top 20 for the Dubai Global Experience." },
// ];

// export const KEY_DATES = [
//   ["Application Opens", "October 1, 2026"],
//   ["Application Closes", "December 31, 2026"],
//   ["Admit Card Released (with exam login)", "January 15, 2027"],
//   ["Online Written Examination", "January 31, 2027"],
//   ["Shortlisted Candidate Result (Written Exam)", "15th February 2027"],
//   ["Interviews (Virtual)", "March 1 – March 31, 2027"],
//   ["Final Shortlist Result", "April 15, 2027"],
//   ["Corporate Launch Program Begins", "June 1, 2027"],
// ];

// export const REGISTRATION_NOTICE = {
//   heading: "CET 2027 — Notification for Batch 1",
//   body: "Applications for CET 2027, Batch 1 are open from October 1, 2026 to December 31, 2026. There is one national testing window per examination cycle. Candidates are advised to complete their application well before the closing date.",
// };

// export const FEE_SECTION = {
//   heading: "Examination Fee",
//   category: "All Applicants",
//   note: "The examination fee covers assessment infrastructure, candidate evaluation, your National Rank Card, and your personalized Corporate Readiness Report. The fee is non-refundable once an application has been submitted.",
// };

// export const DUBAI = {
//   eyebrow: "CET GLOBAL 20",
//   heading: "Dubai Global Experience",
//   body: "The top 20 performing students earn a fully-sponsored 5-night, 6-day corporate immersion program in Dubai — engaging with industry leaders, exploring global business environments, and building a network that extends far beyond graduation.",
//   subheading: "Learn. Explore. Network. Grow.",
//   subbody: "An immersive global experience designed to expose top CET students to international business environments, industry leaders, and new possibilities — a first real look at what a global career can look like.",
//   inclusions: [
//     { title: "Corporate Visits", body: "Tour and engage with organizations operating in Dubai's business ecosystem." },
//     { title: "Meet Global Leaders", body: "Direct interaction with senior industry figures across sectors." },
//     { title: "Interactive Workshops", body: "Hands-on sessions on global business practices." },
//     { title: "Cultural Experience", body: "Exposure to Dubai's business culture and international environment." },
//     { title: "Global Network", body: "Build relationships with peers, mentors, and industry leaders that extend beyond the trip." },
//   ],
//   eligibility: "Eligibility for the Dubai Global Experience is determined solely by performance during the Corporate Launch Program and subsequent employer evaluations. The top 20 ranked candidates are selected — full criteria are published in the How It Works section.",
//   gallery: [
//     { url: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000", caption: "Dubai Downtown & Burj Khalifa" },
//     { url: "https://images.unsplash.com/flagged/photo-1559717865-a99cac1c95d8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000", caption: "The city of the future" },
//     { url: "https://images.unsplash.com/photo-1580674684081-7617fbf3d745?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000", caption: "Waterfront business district" },
//     { url: "https://images.unsplash.com/flagged/photo-1559717201-fbb671ff56b7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000", caption: "Skyline at night" },
//     { url: "https://images.unsplash.com/photo-1543579596-2c11997c7706?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000", caption: "A global business hub" },
//     { url: "https://images.unsplash.com/photo-1634007626524-f47fa37810a7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000", caption: "Where careers go global" },
//   ],
// };

// export const FOUNDER = {
//   eyebrow: "A MESSAGE FROM THE FOUNDER",
//   heading: "Why We Built CET",
//   teaser: "India test produces more graduates every year than almost any country on earth — but very few platforms are built to tell them, objectively, where they stand and where they can go. CET exists to close that gap.",
//   name: "Sarfraz Khan",
//   role: "Founder of Startup Times",
//   message: [
//     "India produces more graduates every year than almost any country on earth — but very few platforms are built to tell them, objectively, where they stand and where they can go. Most students find out whether they're 'corporate ready' only after they've already applied to dozens of jobs and been rejected by most of them. That feedback loop is too slow, too private, and too unfair to students from colleges without strong placement cells.",
//     "CET was built to change that. It gives every student — regardless of college, city, or network — a national rank, a real readiness report, and a direct line to employers who are actually hiring. The students who rise to the top don't just get a certificate; they get three months of real training, real mentorship, and for the top 20, a fully-sponsored trip to Dubai to see what a global career can actually look like.",
//   ],
// };

// export const CLOSING_CTA = {
//   heading: "Your Rank Is Waiting to Be Earned.",
//   body: "Join thousands of students competing for a place in India's Corporate Launch Program — and a shot at Dubai.",
// };

// export const ABOUT = {
//   hero: {
//     eyebrow: "ABOUT CET",
//     heading: "A National Assessment for a New Generation of Talent",
//     body: "The Corporate Entrance Test (CET) is a national-level assessment designed to evaluate the corporate readiness of graduating students and recent graduates across India. CET is organized by Startup Times, in partnership with a growing network of 350+ employers, to build a transparent, merit-based bridge between Indian campuses and the corporate world.",
//   },
//   mission: {
//     heading: "Why CET Exists",
//     body: "Every year, millions of students graduate from Indian colleges with a degree — but no consistent, national way to measure how ready they are for the workplace, and no direct line to the employers actually hiring. CET was built to solve that: a single, credible national exam that gives every student a real rank, a real readiness report, and a real shot at employer evaluation — regardless of which college they come from.",
//   },
//   different: [
//     { title: "National, not institutional.", body: "CET is open to any final-year student or recent graduate in India, not tied to one college or university." },
//     { title: "Merit is public.", body: "Every applicant receives a percentile and National Rank — not just those who are shortlisted." },
//     { title: "Built with employers, not just for them.", body: "350+ organizations are structurally involved in the evaluation and hiring process, not listed as sponsors after the fact." },
//     { title: "A real global outcome.", body: "The top 20 performers earn a fully-sponsored international immersion program — not a certificate, an actual opportunity." },
//   ],
//   organizedBy: {
//     heading: "An Initiative by Startup Times",
//     body: "CET is organized and operated by Startup Times, India's multi-publication entrepreneurship media network encompassing Startup Times, INC91, Business Press, and Gulf Times. Startup Times works closely with founders, enterprises, and institutions across India and the Gulf — CET extends that mission to the country's graduating talent pool.",
//   },
// };

// export const HOW_IT_WORKS = {
//   hero: { heading: "Exam Pattern & Syllabus", body: "A transparent, six-stage national process — from application to a global opportunity." },
//   stages: [
//     { n: 1, title: "Application", body: "Applications are open to final-year students and recent graduates across India. Submit your application between October 1 and December 31, 2026, along with the examination fee of ." },
//     { n: 2, title: "Online Written Examination", body: "The national online examination is held on January 31, 2027. It has 80 questions across 4 sections (20 questions each), a total duration of 1 hour, equal weightage across sections, and negative marking of 1/3 per wrong answer. Sections:", list: ["Quantitative & Logical Reasoning", "Verbal & Communication Ability", "Workplace Judgment & Situational Reasoning", "General Business & Corporate Awareness"] },
//     { n: 3, title: "National Rank & Readiness Report", body: "Within [X weeks] of the examination, every candidate receives:", list: ["A National Rank and percentile", "A personalized Corporate Readiness Report highlighting strengths and areas for growth", "A shareable digital Rank Card"] },
//     { n: 4, title: "Virtual Interviews", body: "Shortlisted candidates are invited for virtual interviews between March 1 and March 31, 2027, conducted by a panel drawn from CET's employer and mentor network." },
//     { n: 5, title: "Final Shortlist", body: "The final list of 1,000 selected candidates is declared on April 15, 2027." },
//     { n: 6, title: "Corporate Launch Program & Beyond", body: "Selected candidates begin the 3-month online Corporate Launch Program on June 1, 2027. Throughout the program, candidates are evaluated by employers from CET's 350+ network. The top 20 performers are selected for the fully-sponsored Dubai Global Experience." },
//   ],
//   examMeta: [
//     ["Total Questions", "80  MCQ"],
//     ["Sections", "4 (20 questions each)"],
//     ["Duration", "1 Hour (60 minutes)"],
//     ["Marking", "Equal weightage · +1 correct"],
//     ["Negative Marking", "−1/3 per wrong answer"],
//     ["Mode", "100% Online"],
//   ],
//  examPattern: [
//   {
//     section: "Quantitative & Logical Reasoning",
//     topics: [ ],
//     questions: "20",
//     weightage: "25%",
//     duration: "15 mins",
//   },
//   {
//     section: "Verbal & Communication Ability",
//     topics: [],
//     questions: "25",
//     weightage: "25%",
//     duration: "15 mins",
//   },

//   {
//     section: "Workplace Judgment & Situational Reasoning",
//     topics: [],
//     questions: "20",
//     weightage: "25%",
//     duration: "15 mins",
//   },

//   {
//     section: "General Business & Corporate Awareness",
//     topics: [],
//     questions: "20",
//     weightage: "25%",
//     duration: "15 mins",
//   },
// ],


// sectionWiseSyllabus: [
//   {
//     section: "Quantitative Aptitude & Numerical Ability / Logical Reasoning & Analytical Ability",
//     topics: [
//       "Number Systems, Percentages, Ratio & Proportion",
//       "Profit & Loss, Simple & Compound Interest",
//       "Time, Speed & Distance; Time & Work",
//       "Averages, Mixtures & Alligations",
//       "Data Interpretation (Tables, Bar Graphs, Pie Charts, Line Graphs)",
//       "Basic Algebra & Data Sufficiency",
//         "Series (Number, Letter, Alpha-Numeric)",
//       "Coding-Decoding",
//       "Blood Relations & Direction Sense",
//       "Syllogisms & Statement-Conclusion",
//       "Seating Arrangement & Puzzles",
//       "Analytical Reasoning & Data Sufficiency",
//     ],
//     questions: "20",
//     weightage: "25%",
//     duration: "15 mins",
//   },

//   {
//     section: "Verbal Ability & English Comprehension",
//     topics: [
//       "Reading Comprehension",
//       "Grammar & Sentence Correction",
//       "Vocabulary (Synonyms, Antonyms, Fill in the Blanks)",
//       "Para Jumbles & Sentence Completion",
//       "Business & Professional Email Etiquette (Basic)",
//     ],
//     questions: "20",
//     weightage: "25%",
//     duration: "15 mins",
//   },

//   {
//     section: "General Awareness & Corporate Knowledge",
//     topics: [
//       "Current Affairs (Business & Economy Focus)",
//       "Indian Economy & Corporate Sector Basics",
//       "Major Industries, Companies & Business Terminology",
//       "Government Policies Relevant to Business & Startups",
//     ],
//     questions: "20",
//     weightage: "25%",
//     duration: "15 mins",
//   },

//   {
//     section: "Workplace Judgment & Situational Reasoning",
//     topics: [
//       "Situational Judgment Test (SJT)-style scenarios evaluating workplace decision-making",
//       "Professional Ethics & Conduct",
//       "Teamwork, Communication & Conflict-Resolution Scenarios",
//       "Time & Priority Management Scenarios",
//     ],
//     questions: "20",
//     weightage: "25%",
//     duration: "15 mins",
//   },
// ],

// importantDetails: [
//   {
//     n: "1",
//     title: "Eligibility Criteria",
//     list: [
//       "Must be a final-year student (any stream) at a recognized Indian college/university, OR a graduate within 2 years of completing their degree.",
//       "No minimum percentage/CGPA requirement to apply.",
//       "No age limit.",
//       "Indian citizens only."
//     ]
//   },

//   {
//     n: "2",
//     title: "System Requirements (Online Exam & Interview)",
//     body: "Since both the exam and the interview are conducted online, candidates will need:",
//     list: [
//       "A laptop or desktop computer with a working webcam (mobile phones are not permitted for the exam).",
//       "Stable internet connection.",
//       "Updated Chrome or Firefox browser.",
//       "A quiet, well-lit room for the duration of the exam and interview.",
//       "A valid government ID for identity verification before both the exam and interview begin."
//     ]
//   },

//   {
//     n: "3",
//     title: "Admit Card",
//     list: [
//       "Admit cards will be released exactly 2 weeks before the exam date on the candidate's login dashboard.",
//       "Candidates must display their admit card and a valid government ID at the start of the exam for verification.",
//       "A separate interview call letter will be issued to shortlisted candidates ahead of the March 1–31, 2027 interview window."
//     ]
//   },

//   {
//     n: "4",
//     title: "Exam Day Instructions",
//     list: [
//       "Candidates should log in at least 30 minutes before the scheduled slot.",
//       "System and webcam checks must be completed before the exam starts.",
//       "No external material, second devices, or assistance is permitted during the exam.",
//       "Any deviation from the candidate's webcam frame or evidence of malpractice may result in disqualification."
//     ]
//   },

//   {
//     n: "5",
//     title: "Malpractice & Disqualification Policy",
//     body: "CET has zero tolerance for malpractice. Any candidate found impersonating another individual, using unauthorized assistance or material, or attempting to bypass remote proctoring will be permanently disqualified and barred from future CET examination cycles. This policy exists to protect the credibility of every candidate's National Rank."
//   },

//   {
//     n: "6",
//     title: "Result & Scorecard",
//     list: [
//       "Results are declared on the candidate's login dashboard.",
//       "Every candidate receives a digital scorecard with sectional breakup, overall percentile, and National Rank.",
//       "Scorecards are downloadable as PDF and shareable as a digital Rank Card."
//     ]
//   },

//   {
//     n: "7",
//     title: "Grievance Redressal & Helpdesk",
//     list: [
//       "A dedicated helpdesk (email/phone/WhatsApp) will be available for application, payment, and exam-day issues.",
//       "Candidates may raise result-related grievances within the specified period after result declaration; a review committee will respond within the specified response period."
//     ]
//   },

//   {
//     n: "8",
//     title: "Certificate & Rank Validity",
//     list: [
//       "The National Rank and Corporate Readiness Report from CET 2027 are valid for employer evaluation purposes for 6 months from the date of result declaration.",
//       "Candidates may reapply in a future CET cycle to improve their rank."
//     ]
//   },

//   {
//     n: "9",
//     title: "Terms, Privacy & Data Use",
//     body: "By applying, candidates consent to CET and Startup Times using their application data, exam performance, and (for shortlisted candidates) interview outcomes for the purposes of evaluation, employer matching, and communication about CET programs. Full Terms & Conditions and Privacy Policy should be linked in the site footer and referenced in the application form's declaration step."
//   }
// ],
//   selection: {
//     heading: "How Candidates Are Selected",
//     intro: "Official exams gain credibility from publishing exact weightages.",
//     shortlist: [
//       ["Written Examination Score", "60% (of shortlist evaluation)"],
//       ["Interview Performance", "40% (of shortlist evaluation)"],
//     ],
//     top20: [
//       ["Employer Evaluation Score", "40%"],
//       ["Trainer Evaluation Score", "30%"],
//       ["Attendance & Participation", "20%"],
//       ["Dedication & Professionalism", "10%"],
//     ],
//     top20Criteria: [
//       { title: "Employer Evaluation Score", weight: "40%", body: "Scores assigned by participating employers across module assignments, live projects, and the capstone assessment center throughout the program." },
//       { title: "Trainer Evaluation Score", weight: "30%", body: "Assessments from CET program trainers and mentors on skills, improvement, assignment quality, and readiness across the 9 modules." },
//       { title: "Attendance & Participation", weight: "20%", body: "Consistent attendance in live sessions and mentor office hours, plus active participation in group discussions and activities." },
//       { title: "Dedication & Professionalism", weight: "10%", body: "Deadlines met, initiative, discipline, and workplace-conduct benchmarks demonstrated throughout the 3-month program." },
//     ],
//     note: "Entry to the Corporate Launch Program (top 1,000) is based on the exam + interview (60% / 40%). The Top 20 for Dubai are then ranked purely on program performance — employer and trainer evaluation scores combined with attendance and dedication.",
//   },
// };

// export const PROGRAM = {
//   hero: {
//     eyebrow: "FOR THE TOP 1,000",
//     heading: "The Corporate Launch Program",
//     body: "A 3-month, fully-sponsored, fully online training and mentorship program designed to take shortlisted candidates from \"graduate\" to \"corporate ready\" — built and delivered with CET's network of 350+ employers. Beyond training, candidates receive a formal Internship Certificate and stand a real chance at a job offer from a participating employer.",
//   },
//   format: "100% Online",
//   modules: [
//     { n: 1, title: "Professional Communication & Business Writing", body: "Email etiquette, business documentation, verbal and presentation skills." },
//     { n: 2, title: "Resume Building & Personal Branding", body: "Resume/CV construction, LinkedIn profile optimization, personal positioning for recruiters." },
//     { n: 3, title: "Corporate Etiquette & Workplace Behavior", body: "Professional conduct, workplace communication norms, cross-team collaboration." },
//     { n: 4, title: "Digital & Business Tools", body: "Practical proficiency in Excel, PowerPoint, and commonly used workplace software." },
//     { n: 5, title: "Sales, Negotiation & Client Communication", body: "Foundational commercial skills relevant across functions, not just sales roles." },
//     { n: 6, title: "Interview Skills & Group Discussion Practice", body: "Mock interviews, group discussions, and employer-facing evaluation simulations." },
//     { n: 7, title: "Domain Foundations", body: "Track-based sessions across IT & Consulting, BFSI, Marketing, and Operations, based on candidate interest." },
//     { n: 8, title: "Live Projects & Case Studies", body: "Applied assignments and case studies guided by mentors from the employer network." },
//     { n: 9, title: "Capstone Evaluation", body: "A final, employer-assessed project/assessment center used as a key input for Top 20 selection." },
//   ],
//   formatPoints: [
//     { title: "Delivery", body: "100% online — live sessions, recorded modules, and mentor office hours." },
//     { title: "Mentorship", body: "Ongoing guidance from industry practitioners across CET's employer network." },
//     { title: "Evaluation", body: "Continuous employer assessment throughout the program, not just at entry or exit." },
//     { title: "Direct Employer Access", body: "Structured interactions and evaluation opportunities with organizations actively hiring." },
//   ],
//   timeline: [
//     ["Program Begins", "June 1, 2027"],
//     ["Program Duration", "3 Months (Online)"],
//     ["Program Ends", "August 31, 2027"],
//     ["Employer Evaluations", "Throughout the program"],
//     ["Top 20 Announcement", "September 1, 2027"],
//   ],
//   outcomes: [
//     "A Training Certificate recognizing completion of the Corporate Launch Program.",
//     "A formal Internship Certificate, issued for the duration of the program.",
//     "Real job opportunities — candidates are evaluated by participating employers throughout the program, with the possibility of a direct job offer from a hiring employer.",
//     "Direct evaluation history with employers from a 350+ network.",
//     "For the Top 20: a fully-sponsored place on the Dubai Global Experience.",
//   ],
// };

// export const FAQS = [
//   { q: "Who can apply for CET?", a: "Final-year students and recent graduates from any recognized college or university in India." },
//   { q: "What is the examination fee?", a: " payable at the time of application. See the Examination Fee section for details." },
//   { q: "Is the fee refundable?", a: "No. The fee covers assessment infrastructure, your Corporate Readiness Report, and your National Rank Card." },
//   { q: "What is the exam pattern?", a: "The online exam has 80 questions across 4 sections (20 questions each), a total duration of 1 hour, equal weightage across sections, and negative marking of 1/3 per wrong answer." },
//   { q: "What are the important dates for CET 2027?", a: "Applications: October 1 – December 31, 2026. Online Written Examination: January 31, 2027. Virtual Interviews: March 1–31, 2027. Final Result: April 15, 2027. Program Start: June 1, 2027." },
//   { q: "How are the top 1,000 and top 20 selected?", a: "The shortlist of 1,000 is based on a 60% written / 40% interview weightage. The Top 20 for Dubai are selected separately based on Corporate Launch Program performance and employer evaluations — see the Selection Criteria section on the How It Works page." },
//   { q: "Where are the interviews held?", a: "Interviews for CET 2027 are conducted virtually (online) between March 1 and March 31, 2027." },
//   { q: "Is the Corporate Launch Program really free of cost?", a: "Yes — candidates selected into the Corporate Launch Program are not charged any additional fee. The 3-month program is fully online and sponsored through CET's employer and partner network." },
//   { q: "Is the Dubai Global Experience really fully sponsored?", a: "Yes — travel and stay for the top 20 selected candidates are fully sponsored. No additional payment is required from selected candidates." },
//   { q: "Who organizes CET?", a: "CET is an initiative by Startup Times, India's multi-publication entrepreneurship media network, and is operated by Devobyte OPC Private Limited." },
//   { q: "I don't make the top 1,000 — is that it?", a: "No. Every applicant receives their National Rank, percentile, and Corporate Readiness Report regardless of outcome, and is invited to join the CET community for future opportunities, job postings, and the next examination cycle." },
// ];

// export const BLOG = {
//   hero: { heading: "Insights for India's Next Generation of Corporate Leaders", body: "Career readiness, employer expectations, exam preparation, and stories from the CET community." },
//   categories: ["Exam Prep", "Corporate Readiness", "Employer Spotlights", "Candidate Stories", "CET Notifications"],
//   posts: [
//     { title: "Cracking CET: A Starter Study Plan for Reasoning & Aptitude", category: "Exam Prep", excerpt: "A practical week-by-week approach to building the core reasoning and aptitude skills the CET written exam evaluates.", date: "Coming soon" },
//     { title: "What 'Corporate Ready' Actually Means to Employers", category: "Corporate Readiness", excerpt: "Communication, judgment, and professionalism — the signals recruiters look for beyond your degree.", date: "Coming soon" },
//     { title: "Inside the Employer Network: How Hiring Partners Evaluate Talent", category: "Employer Spotlights", excerpt: "How CET's 350+ employer network participates in evaluation — and what they value most.", date: "Coming soon" },
//     { title: "From Campus to Corporate: A Candidate's Journey", category: "Candidate Stories", excerpt: "A template for the stories of Corporate Launch Program participants and Dubai Global Experience alumni.", date: "Coming soon" },
//     { title: "CET 2027 Batch 1 — Official Notification & Key Dates", category: "CET Notifications", excerpt: "Everything you need to know about the CET 2027 Batch 1 examination cycle, dates, and process.", date: "Coming soon" },
//   ],
// };



/**
 * Static site content sourced from CET-Website-Copy.md + client updates.
 * Program is 100% online; interviews are virtual.
 */

export const LEGAL = {
  brandName: "CET",
  brandFull: "Corporate Entrance Test",
  initiativeBy: "Startup Times",
  legalEntity: "Devobyte OPC Private Limited",
  email: "help@corporateentrancetest.com",
  addressLine: "Corporate Address : A-522, Tower T3, NX One, Tech Zone 4, Noida Extension, Uttar Pradesh 201306",
  startupTimes: {
    website: "https://startuptimes.net/",
    instagram: "https://www.instagram.com/startuptimesofficial/",
    linkedin: "https://www.linkedin.com/company/startup-times",
  },
};

export const ASSETS = {
  startupTimesLogo:
    "https://customer-assets-0z36b82j.emergentagent.net/job_cet-portal-1/artifacts/ezcwih7h_ST%20Logo.png",
  founderPhoto:
    "https://customer-assets-0z36b82j.emergentagent.net/job_cet-portal-1/artifacts/1genlp59_sarfrazkhan.png",
  heroSkyline:
    "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const IMAGES = {
  graduatesRed: "https://static.prod-images.emergentagent.com/jobs/465b9496-4539-488c-85f4-478366c7c0e4/images/d50d2c52b5bad49fcc4af9b8361cc1175898e9b381a8533db06090cb108f1f9c.jpeg",
  capToss: "https://static.prod-images.emergentagent.com/jobs/465b9496-4539-488c-85f4-478366c7c0e4/images/514045a065e9cc7330166ed032e059f0da22487d593f9a1fdee9b9a4983e56f0.jpeg",
  capToss2: "https://static.prod-images.emergentagent.com/jobs/465b9496-4539-488c-85f4-478366c7c0e4/images/d50d2c52b5bad49fcc4af9b8361cc1175898e9b381a8533db06090cb108f1f9c.jpeg",
  onlineLearning: "https://static.prod-images.emergentagent.com/jobs/465b9496-4539-488c-85f4-478366c7c0e4/images/fb666feedcb23a09df5d5e82001223b0e53bfc9209e7722f5139b67274d2d755.jpeg",
  laptopStudy: "https://static.prod-images.emergentagent.com/jobs/465b9496-4539-488c-85f4-478366c7c0e4/images/8d353cb795a72ec7ceb2a32975a3ec8ca64ea721d789bcbbfe48c6508a861c87.jpeg",
  study2: "https://static.prod-images.emergentagent.com/jobs/465b9496-4539-488c-85f4-478366c7c0e4/images/f28bbbec7e15d19775b446c55f294ecf6a1aec8d4fc2e92fecab05f62fabca28.jpeg",
  networking: "https://static.prod-images.emergentagent.com/jobs/465b9496-4539-488c-85f4-478366c7c0e4/images/8d353cb795a72ec7ceb2a32975a3ec8ca64ea721d789bcbbfe48c6508a861c87.jpeg",
};

export const SITE = {
  applicationCloseDate: "2026-12-31T23:59:59+05:30",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Exam Pattern & Syllabus", to: "/exam-pattern-and-syllabus" },
  { label: "Program", to: "/program" },
  { label: "Dubai Experience", to: "/dubai-experience" },
  { label: "FAQs", to: "/faqs" },
  { label: "Blog", to: "/blog" },
];

export const HERO = {
  eyebrow: "A NATIONAL PLATFORM CONNECTING STUDENTS WITH CORPORATE OPPORTUNITIES",
  headlineTop: "Your Degree Gets You Started.",
  headlineAccent: "CET Gets You in Front of Employers.",
  subhead:
    "Take India's Corporate Entrance Test. Earn your National Rank, enter the Corporate Launch Program, gain practical corporate exposure, and get evaluated by a network of 350+ employers for potential career opportunities.",
  tagline: "From Your Campus to Corporate Opportunities",
  sideIcons: [
    "Corporate Exposure",
    "Employer Connections",
    "Career Opportunities",
    "Global Exposure",
  ],
  microcopy:
    "For final year students & recent graduates · Applications open October 1, 2026. One national testing window per cycle",
};

export const STATS = [
  { value: "1,000", label: "Selected for the Corporate Launch Program" },
  { value: "20", label: "Top Performers Go to Dubai" },
  { value: "350+", label: "Participating Employers" },
  { value: "3 Months", label: "Fully-Sponsored Corporate Training" },
  // { value: "₹250", label: "Application Fee" },
];

export const EMPLOYER_SECTION = {
  heading: "Your Next Step Could Be a Corporate Opportunity",
  subheading:
    "Get trained, build your corporate skills, and be evaluated by participating employers across industries.",
  industries: [
    { name: "IT & Consulting", icon: "Code2" },
    { name: "BFSI", icon: "Landmark" },
    { name: "Manufacturing & Core", icon: "Factory" },
    { name: "Marketing & Media", icon: "Megaphone" },
    { name: "Operations & Supply Chain", icon: "Truck" },
    { name: "High-Growth Startups", icon: "Rocket" },
  ],
};

export const JOURNEY_STEPS = [
  {
    n: "01",
    title: "Apply for CET",
    body: "Submit your application between October 1 and December 31, 2026.",
  },
  {
    n: "02",
    title: "Take the Test",
    body: "Appear for the national online examination on January 31, 2027 — 80 questions across reasoning, aptitude, communication and workplace judgment.",
  },
  {
    n: "03",
    title: "Get Your Rank",
    body: "Receive your National Rank, percentile, and a personalized Corporate Readiness Report.",
  },
  {
    n: "04",
    title: "Interviews",
    body: "Shortlisted candidates are interviewed virtually between March 1 and March 31, 2027.",
  },
  {
    n: "05",
    title: "Join the Corporate Launch Program",
    body: "The final list of 1,000 selected candidates is declared on April 15, 2027. Selected candidates move into the fully sponsored Corporate Launch Program.",
  },
  {
    n: "06",
    title: "Train. Perform. Get Evaluated.",
    body: "The 3-month online Corporate Launch Program begins June 1, 2027. Candidates build workplace skills, work on practical assignments, and are evaluated by participating employers for potential career opportunities. The Top 20 are selected for the Dubai Global Experience.",
  },
];

export const KEY_DATES = [
  ["Application Opens", "October 1, 2026"],
  ["Application Closes", "December 31, 2026"],
  ["Admit Card Released (with exam login)", "January 15, 2027"],
  ["Online Written Examination", "January 31, 2027"],
  ["Shortlisted Candidate Result (Written Exam)", "15th February 2027"],
  ["Interviews (Virtual)", "March 1 – March 31, 2027"],
  ["Final Shortlist Result", "April 15, 2027"],
  ["Corporate Launch Program Begins", "June 1, 2027"],
];

export const REGISTRATION_NOTICE = {
  heading: "CET 2027 — Notification for Batch 1",
  body:
    "Applications for CET 2027, Batch 1 are open from October 1, 2026 to December 31, 2026. There is one national testing window per examination cycle. Candidates are advised to complete their application well before the closing date.",
};

export const FEE_SECTION = {
  heading: "Examination Fee",
  category: "All Applicants",
  note:
    "The examination fee is ₹250. It covers assessment infrastructure, candidate evaluation, your National Rank Card, and your personalized Corporate Readiness Report. The fee is non-refundable once an application has been submitted.",
};

export const DUBAI = {
  eyebrow: "CET GLOBAL 20",
  heading: "Dubai Global Experience",
  body:
    "The Top 20 performing students earn a fully-sponsored 5-night, 6-day corporate immersion program in Dubai — engaging with industry leaders, exploring global business environments, and building a network that extends far beyond graduation.",
  subheading: "Learn. Explore. Network. Grow.",
  subbody:
    "An immersive global experience designed to expose top CET students to international business environments, industry leaders, and new possibilities — a first real look at what a global career can look like.",
  inclusions: [
    {
      title: "Corporate Visits",
      body: "Tour and engage with organizations operating in Dubai's business ecosystem.",
    },
    {
      title: "Meet Global Leaders",
      body: "Direct interaction with senior industry figures across sectors.",
    },
    {
      title: "Interactive Workshops",
      body: "Hands-on sessions on global business practices.",
    },
    {
      title: "Cultural Experience",
      body: "Exposure to Dubai's business culture and international environment.",
    },
    {
      title: "Global Network",
      body: "Build relationships with peers, mentors, and industry leaders that extend beyond the trip.",
    },
  ],
  eligibility:
    "Eligibility for the Dubai Global Experience is determined solely by performance during the Corporate Launch Program and subsequent employer evaluations. The Top 20 ranked candidates are selected — full criteria are published in the How It Works section.",
  gallery: [
    {
      url: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
      caption: "Dubai Downtown & Burj Khalifa",
    },
    {
      url: "https://images.unsplash.com/flagged/photo-1559717865-a99cac1c95d8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
      caption: "The city of the future",
    },
    {
      url: "https://images.unsplash.com/photo-1580674684081-7617fbf3d745?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
      caption: "Waterfront business district",
    },
    {
      url: "https://images.unsplash.com/flagged/photo-1559717201-fbb671ff56b7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
      caption: "Skyline at night",
    },
    {
      url: "https://images.unsplash.com/photo-1543579596-2c11997c7706?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
      caption: "A global business hub",
    },
    {
      url: "https://images.unsplash.com/photo-1634007626524-f47fa37810a7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
      caption: "Where careers go global",
    },
  ],
};

export const FOUNDER = {
  eyebrow: "A MESSAGE FROM THE FOUNDER",
  heading: "Why We Built CET",
  teaser:
    "India produces millions of graduates every year, but students often lack a clear way to understand their corporate readiness and get in front of employers. CET exists to help close that gap.",
  name: "Sarfraz Khan",
  role: "Founder of Startup Times",
  message: [
    "India produces more graduates every year than almost any country on earth — but very few platforms are built to tell them, objectively, where they stand and where they can go. Most students find out whether they're 'corporate ready' only after they've already applied to dozens of jobs and been rejected by most of them. That feedback loop is too slow, too private, and too unfair to students from colleges without strong placement cells.",
    "CET was built to change that. It gives every student — regardless of college, city, or network — a national rank, a real readiness report, and a direct line to employers who are actually hiring. The students who rise to the top don't just get a certificate; they get three months of real training, real mentorship, and for the Top 20, a fully-sponsored trip to Dubai to see what a global career can actually look like.",
  ],
};

export const CLOSING_CTA = {
  heading: "Don't Just Graduate. Get in Front of Employers.",
  body:
    "Take CET, earn your National Rank, build your corporate readiness, enter the Corporate Launch Program, and get evaluated by 350+ employers for potential career opportunities — with the Top 20 competing for a fully sponsored Dubai Global Experience.",
};

export const ABOUT = {
  hero: {
    eyebrow: "ABOUT CET",
    heading: "A National Platform Connecting Talent With the Corporate World",
    body:
      "The Corporate Entrance Test (CET) is a national-level platform designed to assess the corporate readiness of graduating students and recent graduates across India. CET connects assessment with corporate training, employer evaluation, and potential career opportunities through a growing network of 350+ employers.",
  },

  mission: {
    heading: "Why CET Exists",
    body:
      "Every year, millions of students graduate from Indian colleges with a degree — but many have no consistent, national way to measure their workplace readiness or get in front of employers. CET was built to create that bridge: a national assessment followed by corporate training and employer evaluation, giving selected candidates a structured opportunity to build skills and compete for career opportunities.",
  },

  different: [
    {
      title: "National, not institutional.",
      body:
        "CET is open to any final-year student or recent graduate in India, not tied to one college or university.",
    },
    {
      title: "Merit is public.",
      body:
        "Every applicant receives a percentile and National Rank — not just those who are shortlisted.",
    },
    {
      title: "Built with employers.",
      body:
        "350+ organizations are part of the employer evaluation ecosystem, giving selected candidates structured opportunities to interact with and be evaluated by participating employers.",
    },
    {
      title: "A real global opportunity.",
      body:
        "The Top 20 performers earn a fully-sponsored international immersion program in Dubai, designed to provide exposure to global business environments.",
    },
  ],

  organizedBy: {
    heading: "An Initiative by Startup Times",
    body:
      "CET is organized and operated by Startup Times, India's multi-publication entrepreneurship media network encompassing Startup Times, INC91, Business Press, and Gulf Times. Startup Times works closely with founders, enterprises, and institutions across India and the Gulf — CET extends that mission to the country's graduating talent pool.",
  },
};

export const HOW_IT_WORKS = {
  hero: {
    heading: "Exam Pattern & Syllabus",
    body:
      "A transparent, six-stage national process — from application to corporate training, employer evaluation and global opportunity.",
  },

  stages: [
    {
      n: 1,
      title: "Application",
      body:
        "Applications are open to final-year students and recent graduates across India. Submit your application between October 1 and December 31, 2026, along with the examination fee of ₹250.",
    },

    {
      n: 2,
      title: "Online Written Examination",
      body:
        "The national online examination is held on January 31, 2027. It has 80 questions across 4 sections (20 questions each), a total duration of 1 hour, equal weightage across sections, and negative marking of 1/3 per wrong answer. Sections:",
      list: [
        "Quantitative & Logical Reasoning",
        "Verbal & Communication Ability",
        "Workplace Judgment & Situational Reasoning",
        "General Business & Corporate Awareness",
      ],
    },

    {
      n: 3,
      title: "National Rank & Readiness Report",
      body:
        "Within [X weeks] of the examination, every candidate receives:",
      list: [
        "A National Rank and percentile",
        "A personalized Corporate Readiness Report highlighting strengths and areas for growth",
        "A shareable digital Rank Card",
      ],
    },

    {
      n: 4,
      title: "Virtual Interviews",
      body:
        "Shortlisted candidates are invited for virtual interviews between March 1 and March 31, 2027, conducted by a panel drawn from CET's employer and mentor network.",
    },

    {
      n: 5,
      title: "Final Shortlist",
      body:
        "The final list of 1,000 selected candidates is declared on April 15, 2027. These candidates move into the fully sponsored Corporate Launch Program.",
    },

    {
      n: 6,
      title: "Corporate Launch Program & Beyond",
      body:
        "Selected candidates begin the 3-month online Corporate Launch Program on June 1, 2027. Throughout the program, candidates receive corporate training, work on practical assignments, and are evaluated by employers from CET's 350+ network for potential career opportunities. The Top 20 performers are selected for the fully-sponsored Dubai Global Experience.",
    },
  ],

  examMeta: [
    ["Total Questions", "80 MCQ"],
    ["Sections", "4 (20 questions each)"],
    ["Duration", "1 Hour (60 minutes)"],
    ["Marking", "Equal weightage · +1 correct"],
    ["Negative Marking", "−1/3 per wrong answer"],
    ["Mode", "100% Online"],
  ],

  examPattern: [
    {
      section: "Quantitative & Logical Reasoning",
      topics: [],
      questions: "20",
      weightage: "25%",
      duration: "15 mins",
    },

    {
      section: "Verbal & Communication Ability",
      topics: [],
      questions: "20",
      weightage: "25%",
      duration: "15 mins",
    },

    {
      section: "Workplace Judgment & Situational Reasoning",
      topics: [],
      questions: "20",
      weightage: "25%",
      duration: "15 mins",
    },

    {
      section: "General Business & Corporate Awareness",
      topics: [],
      questions: "20",
      weightage: "25%",
      duration: "15 mins",
    },
  ],

  sectionWiseSyllabus: [
    {
      section:
        "Quantitative Aptitude & Numerical Ability / Logical Reasoning & Analytical Ability",
      topics: [
        "Number Systems, Percentages, Ratio & Proportion",
        "Profit & Loss, Simple & Compound Interest",
        "Time, Speed & Distance; Time & Work",
        "Averages, Mixtures & Alligations",
        "Data Interpretation (Tables, Bar Graphs, Pie Charts, Line Graphs)",
        "Basic Algebra & Data Sufficiency",
        "Series (Number, Letter, Alpha-Numeric)",
        "Coding-Decoding",
        "Blood Relations & Direction Sense",
        "Syllogisms & Statement-Conclusion",
        "Seating Arrangement & Puzzles",
        "Analytical Reasoning & Data Sufficiency",
      ],
      questions: "20",
      weightage: "25%",
      duration: "15 mins",
    },

    {
      section: "Verbal Ability & English Comprehension",
      topics: [
        "Reading Comprehension",
        "Grammar & Sentence Correction",
        "Vocabulary (Synonyms, Antonyms, Fill in the Blanks)",
        "Para Jumbles & Sentence Completion",
        "Business & Professional Email Etiquette (Basic)",
      ],
      questions: "20",
      weightage: "25%",
      duration: "15 mins",
    },

    {
      section: "General Awareness & Corporate Knowledge",
      topics: [
        "Current Affairs (Business & Economy Focus)",
        "Indian Economy & Corporate Sector Basics",
        "Major Industries, Companies & Business Terminology",
        "Government Policies Relevant to Business & Startups",
      ],
      questions: "20",
      weightage: "25%",
      duration: "15 mins",
    },

    {
      section: "Workplace Judgment & Situational Reasoning",
      topics: [
        "Situational Judgment Test (SJT)-style scenarios evaluating workplace decision-making",
        "Professional Ethics & Conduct",
        "Teamwork, Communication & Conflict-Resolution Scenarios",
        "Time & Priority Management Scenarios",
      ],
      questions: "20",
      weightage: "25%",
      duration: "15 mins",
    },
  ],

  importantDetails: [
    {
      n: "1",
      title: "Eligibility Criteria",
      list: [
        "Must be a final-year student (any stream) at a recognized Indian college/university, OR a graduate within 2 years of completing their degree.",
        "No minimum percentage/CGPA requirement to apply.",
        "No age limit.",
        "Indian citizens only.",
      ],
    },

    {
      n: "2",
      title: "System Requirements (Online Exam & Interview)",
      body:
        "Since both the exam and the interview are conducted online, candidates will need:",
      list: [
        "A laptop or desktop computer with a working webcam (mobile phones are not permitted for the exam).",
        "Stable internet connection.",
        "Updated Chrome or Firefox browser.",
        "A quiet, well-lit room for the duration of the exam and interview.",
        "A valid government ID for identity verification before both the exam and interview begin.",
      ],
    },

    {
      n: "3",
      title: "Admit Card",
      list: [
        "Admit cards will be released exactly 2 weeks before the exam date on the candidate's login dashboard.",
        "Candidates must display their admit card and a valid government ID at the start of the exam for verification.",
        "A separate interview call letter will be issued to shortlisted candidates ahead of the March 1–31, 2027 interview window.",
      ],
    },

    {
      n: "4",
      title: "Exam Day Instructions",
      list: [
        "Candidates should log in at least 30 minutes before the scheduled slot.",
        "System and webcam checks must be completed before the exam starts.",
        "No external material, second devices, or assistance is permitted during the exam.",
        "Any deviation from the candidate's webcam frame or evidence of malpractice may result in disqualification.",
      ],
    },

    {
      n: "5",
      title: "Malpractice & Disqualification Policy",
      body:
        "CET has zero tolerance for malpractice. Any candidate found impersonating another individual, using unauthorized assistance or material, or attempting to bypass remote proctoring will be permanently disqualified and barred from future CET examination cycles. This policy exists to protect the credibility of every candidate's National Rank.",
    },

    {
      n: "6",
      title: "Result & Scorecard",
      list: [
        "Results are declared on the candidate's login dashboard.",
        "Every candidate receives a digital scorecard with sectional breakup, overall percentile, and National Rank.",
        "Scorecards are downloadable as PDF and shareable as a digital Rank Card.",
      ],
    },

    {
      n: "7",
      title: "Grievance Redressal & Helpdesk",
      list: [
        "A dedicated helpdesk (email/phone/WhatsApp) will be available for application, payment, and exam-day issues.",
        "Candidates may raise result-related grievances within the specified period after result declaration; a review committee will respond within the specified response period.",
      ],
    },

    {
      n: "8",
      title: "Certificate & Rank Validity",
      list: [
        "The National Rank and Corporate Readiness Report from CET 2027 are valid for employer evaluation purposes for 6 months from the date of result declaration.",
        "Candidates may reapply in a future CET cycle to improve their rank.",
      ],
    },

    {
      n: "9",
      title: "Terms, Privacy & Data Use",
      body:
        "By applying, candidates consent to CET and Startup Times using their application data, exam performance, and (for shortlisted candidates) interview outcomes for the purposes of evaluation, employer matching, and communication about CET programs. Full Terms & Conditions and Privacy Policy should be linked in the site footer and referenced in the application form's declaration step.",
    },
  ],

  selection: {
    heading: "How Candidates Are Selected",
    intro:
      "Official exams gain credibility from publishing exact weightages.",

    shortlist: [
      ["Written Examination Score", "60% (of shortlist evaluation)"],
      ["Interview Performance", "40% (of shortlist evaluation)"],
    ],

    top20: [
      ["Employer Evaluation Score", "40%"],
      ["Trainer Evaluation Score", "30%"],
      ["Attendance & Participation", "20%"],
      ["Dedication & Professionalism", "10%"],
    ],

    top20Criteria: [
      {
        title: "Employer Evaluation Score",
        weight: "40%",
        body:
          "Scores assigned by participating employers across module assignments, live projects, and the capstone assessment center throughout the program.",
      },

      {
        title: "Trainer Evaluation Score",
        weight: "30%",
        body:
          "Assessments from CET program trainers and mentors on skills, improvement, assignment quality, and readiness across the 9 modules.",
      },

      {
        title: "Attendance & Participation",
        weight: "20%",
        body:
          "Consistent attendance in live sessions and mentor office hours, plus active participation in group discussions and activities.",
      },

      {
        title: "Dedication & Professionalism",
        weight: "10%",
        body:
          "Deadlines met, initiative, discipline, and workplace-conduct benchmarks demonstrated throughout the 3-month program.",
      },
    ],

    note:
      "Entry to the Corporate Launch Program (Top 1,000) is based on the exam + interview (60% / 40%). The Top 20 for Dubai are then ranked purely on program performance — employer and trainer evaluation scores combined with attendance and dedication.",
  },
};

export const PROGRAM = {
  hero: {
    eyebrow: "FOR THE TOP 1,000",
    heading: "The Corporate Launch Program",
    body:
      "A 3-month, fully-sponsored, fully online training and mentorship program designed to take shortlisted candidates from \"graduate\" to \"corporate ready\" — built and delivered with CET's network of 350+ employers. Candidates receive structured corporate training, practical exposure, an Internship Certificate, and the opportunity to be evaluated by participating employers for potential job opportunities.",
  },

  format: "100% Online",

  modules: [
    {
      n: 1,
      title: "Professional Communication & Business Writing",
      body:
        "Email etiquette, business documentation, verbal and presentation skills.",
    },

    {
      n: 2,
      title: "Resume Building & Personal Branding",
      body:
        "Resume/CV construction, LinkedIn profile optimization, personal positioning for recruiters.",
    },

    {
      n: 3,
      title: "Corporate Etiquette & Workplace Behavior",
      body:
        "Professional conduct, workplace communication norms, cross-team collaboration.",
    },

    {
      n: 4,
      title: "Digital & Business Tools",
      body:
        "Practical proficiency in Excel, PowerPoint, and commonly used workplace software.",
    },

    {
      n: 5,
      title: "Sales, Negotiation & Client Communication",
      body:
        "Foundational commercial skills relevant across functions, not just sales roles.",
    },

    {
      n: 6,
      title: "Interview Skills & Group Discussion Practice",
      body:
        "Mock interviews, group discussions, and employer-facing evaluation simulations.",
    },

    {
      n: 7,
      title: "Domain Foundations",
      body:
        "Track-based sessions across IT & Consulting, BFSI, Marketing, and Operations, based on candidate interest.",
    },

    {
      n: 8,
      title: "Live Projects & Case Studies",
      body:
        "Applied assignments and case studies guided by mentors from the employer network.",
    },

    {
      n: 9,
      title: "Capstone Evaluation",
      body:
        "A final, employer-assessed project/assessment center used as a key input for Top 20 selection.",
    },
  ],

  formatPoints: [
    {
      title: "Delivery",
      body:
        "100% online — live sessions, recorded modules, and mentor office hours.",
    },

    {
      title: "Mentorship",
      body:
        "Ongoing guidance from industry practitioners across CET's employer network.",
    },

    {
      title: "Evaluation",
      body:
        "Continuous employer assessment throughout the program, not just at entry or exit.",
    },

    {
      title: "Direct Employer Access",
      body:
        "Structured interactions and evaluation opportunities with organizations actively hiring, giving candidates a chance to be considered for potential career opportunities.",
    },
  ],

  timeline: [
    ["Program Begins", "June 1, 2027"],
    ["Program Duration", "3 Months (Online)"],
    ["Program Ends", "August 31, 2027"],
    ["Employer Evaluations", "Throughout the program"],
    ["Top 20 Announcement", "September 1, 2027"],
  ],

  outcomes: [
    "A Training Certificate recognizing completion of the Corporate Launch Program.",
    "A formal Internship Certificate, issued for the duration of the program.",
    "Potential job opportunities — candidates are evaluated by participating employers throughout the program, with the possibility of a direct job offer based on employer requirements and candidate performance.",
    "Direct evaluation history with employers from a 350+ network.",
    "Opportunity to be considered by participating employers for potential internships, employment, or other career opportunities, subject to employer requirements.",
    "For the Top 20: a fully-sponsored place on the Dubai Global Experience.",
  ],
};

export const FAQS = [
  {
    q: "Who can apply for CET?",
    a: "Final-year students and recent graduates from any recognized college or university in India.",
  },

  {
    q: "What is the examination fee?",
    a: "The CET application fee is ₹250, payable at the time of application.",
  },

  {
    q: "Is the fee refundable?",
    a:
      "No. The fee covers assessment infrastructure, your Corporate Readiness Report, and your National Rank Card.",
  },

  {
    q: "What is the exam pattern?",
    a:
      "The online exam has 80 questions across 4 sections (20 questions each), a total duration of 1 hour, equal weightage across sections, and negative marking of 1/3 per wrong answer.",
  },

  {
    q: "What are the important dates for CET 2027?",
    a:
      "Applications: October 1 – December 31, 2026. Online Written Examination: January 31, 2027. Virtual Interviews: March 1–31, 2027. Final Result: April 15, 2027. Program Start: June 1, 2027.",
  },

  {
    q: "How are the top 1,000 and top 20 selected?",
    a:
      "The shortlist of 1,000 is based on a 60% written / 40% interview weightage. The Top 20 for Dubai are selected separately based on Corporate Launch Program performance and employer evaluations — see the Selection Criteria section on the How It Works page.",
  },

  {
    q: "Where are the interviews held?",
    a:
      "Interviews for CET 2027 are conducted virtually (online) between March 1 and March 31, 2027.",
  },

  {
    q: "Is the Corporate Launch Program really free of cost?",
    a:
      "Yes — candidates selected into the Corporate Launch Program are not charged any additional fee. The 3-month program is fully online and sponsored through CET's employer and partner network.",
  },

  {
    q: "Is the Dubai Global Experience really fully sponsored?",
    a:
      "Yes — travel and stay for the top 20 selected candidates are fully sponsored. No additional payment is required from selected candidates.",
  },

  {
    q: "Can I get a job through CET?",
    a:
      "CET gives selected candidates the opportunity to be evaluated by participating employers for potential career and employment opportunities. Employment decisions ultimately depend on candidate performance, employer requirements, and available roles.",
  },

  {
    q: "Who organizes CET?",
    a:
      "CET is an initiative by Startup Times, India's multi-publication entrepreneurship media network, and is operated by Devobyte OPC Private Limited.",
  },

  {
    q: "I don't make the top 1,000 — is that it?",
    a:
      "No. Every applicant receives their National Rank, percentile, and Corporate Readiness Report regardless of outcome, and is invited to join the CET community for future opportunities, job postings, and the next examination cycle.",
  },
];

export const BLOG = {
  hero: {
    heading: "Insights for India's Next Generation of Corporate Talent",
    body:
      "Career readiness, employer expectations, exam preparation, and stories from the CET community.",
  },

  categories: [
    "Exam Prep",
    "Corporate Readiness",
    "Employer Spotlights",
    "Candidate Stories",
    "CET Notifications",
  ],

  posts: [
    {
      title: "Cracking CET: A Starter Study Plan for Reasoning & Aptitude",
      category: "Exam Prep",
      excerpt:
        "A practical week-by-week approach to building the core reasoning and aptitude skills the CET written exam evaluates.",
      date: "Coming soon",
    },

    {
      title: "What 'Corporate Ready' Actually Means to Employers",
      category: "Corporate Readiness",
      excerpt:
        "Communication, judgment, and professionalism — the signals recruiters look for beyond your degree.",
      date: "Coming soon",
    },

    {
      title: "Inside the Employer Network: How Hiring Partners Evaluate Talent",
      category: "Employer Spotlights",
      excerpt:
        "How CET's 350+ employer network participates in evaluation — and what they value most.",
      date: "Coming soon",
    },

    {
      title: "From Campus to Corporate: A Candidate's Journey",
      category: "Candidate Stories",
      excerpt:
        "A template for the stories of Corporate Launch Program participants and Dubai Global Experience alumni.",
      date: "Coming soon",
    },

    {
      title: "CET 2027 Batch 1 — Official Notification & Key Dates",
      category: "CET Notifications",
      excerpt:
        "Everything you need to know about the CET 2027 Batch 1 examination cycle, dates, and process.",
      date: "Coming soon",
    },
  ],
};